// Convierte un número de fila a letra (1=A, 26=Z, 27=AA, ...)
export const filaALetra = (n) => {
  let r = ''
  let x = Number(n) || 1
  while (x > 0) {
    const m = (x - 1) % 26
    r = String.fromCharCode(65 + m) + r
    x = Math.floor((x - 1) / 26)
  }
  return r
}

// Etiqueta visual de una celda. Ej: A1, B16, C2.3 (si profundidad>1)
export const etiquetaCelda = (fila, columna, profundidad, totalProfundidad) => {
  const base = `${filaALetra(fila)}${columna}`
  return totalProfundidad > 1 ? `${base}.${profundidad}` : base
}
